<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-input v-model="model.ChargeBeeCustomerId" type="text" 
                                     label="Customer Id (Optional)" 
                                     autofocus 
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('ChargeBeeCustomerId')"
                                     :error-message="fieldErrorMessage('ChargeBeeCustomerId')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-checkbox v-model="model.EnableAutoCollectPayment" 
                                        label="Auto-collect payments" 
                                         
                                        
                                        
                                        dense>
                                
                                
                            </q-checkbox>
                        </div>
<div class="col-12" v-show="model.EnableAutoCollectPayment === true">
                            <q-input v-model="model.HourOfDayToCheckInvoices" type="number" 
                                     label="Hour of the day to collect payment" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('HourOfDayToCheckInvoices')"
                                     :error-message="fieldErrorMessage('HourOfDayToCheckInvoices')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './chargebeeinvoicessettingseditmodel-dialog-screen.js'
</script>